module.exports = __webpack_public_path__ + "amcharts/images/pencilIcon.gif";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=amcharts/images/[name].[ext]!./~/amstock3/amcharts/images/pencilIcon.gif
// module id = 276
// module chunks = 0